var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.IsAllowedToView)?_c('el-switch',{staticStyle:{"display":"block"},attrs:{"active-color":"#ff4949","inactive-color":"#13ce66","active-text":"Blocqueadas","inactive-text":"Sin Blocquear"},on:{"change":_vm.handleChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }